/**
 * Project panel
 *
 * Created by stefensuhat on 08/08/18 2.52 PM
 */
import { apiv2 } from 'utils/index';

export const query = (params) => fetch.get('products', { params });
const baseUrl = (merchantId) => `merchants/${merchantId}/products`;

const defaultState = {
    items: [],
    menus: [],
    users: [],
    item: {},
    options: [],
    meta: { total: 0, per_page: 0, current_page: 0 },
    menuMeta: { total: 0, per_page: 15, current_page: 0 },
    userMeta: { count: [] },
    statistic: {
        total: 0,
        meta: {},
    },
    errors: null,
    duplicated: false,
};

export default {
    name: 'product',
    state: defaultState,
    reducers: {
        reset: (state) => ({
            ...state,
            item: {},
            saved: false,
            errors: null,
            duplicated: false,
        }),
        fetchResponse: (state, payload) => ({
            ...state,
            items: payload.data,
            meta: payload.meta,
        }),
        fetchMenuResponse: (state, payload) => ({ ...state, menus: payload.data, menuMeta: payload.meta }),
        fetchUserResponse: (state, payload) => ({ ...state, users: payload.data, userMeta: payload.meta }),

        findResponse: (state, payload) => ({
            ...state,
            item: payload,
        }),
        saveResponse: (state, payload) => {
            if (payload.errors) {
                return {
                    ...state,
                    errors: payload.errors,
                    saved: false,
                };
            }

            return {
                ...state,
                saved: true,
                errors: null,
            };
        },
    },
    effects: {
        async fetch({ merchantId, query }) {
            await apiv2.get(baseUrl(merchantId), { params: query })
                .then((response) => this.fetchResponse(response));
        },

        async find({ merchantId, productId }) {
            await apiv2.get(`merchants/${merchantId}/products/${productId}`)
                .then((response) => this.findResponse(response));
        },
        async fetchMenu({ product_id, params }) {
            await apiv2.get(`products/${product_id}/menus`, { params })
                .then((response) => this.fetchMenuResponse(response));
        },
        async save(formData) {
            this.saveLoading();
            const getId = formData.get('id');
            const url = getId ? `menus/${getId}` : 'menus';

            await fetch.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
                .then((response) => this.saveResponse(response));
        },

        async fetchUser({ productId, dates }) {
            await apiv2.get(`products/${productId}/users`, { params: { dates } })
                .then((response) => this.fetchUserResponse(response));
        },
    },
    selectors: (slice, createSelector) => ({
        all() {
            return createSelector(slice, (state) => state.menu, (menu) => menu.items);
        },
        find() {
            return createSelector(
                this.all,
                (state, selectedId) => selectedId,
                (menus, selectedId) => menus.find((menu) => menu.id === selectedId),
            );
        },
    }),
};
